import { render, staticRenderFns } from "./supplierNameStatus.vue?vue&type=template&id=353fec18&scoped=true"
import script from "./supplierNameStatus.vue?vue&type=script&lang=js"
export * from "./supplierNameStatus.vue?vue&type=script&lang=js"
import style0 from "./supplierNameStatus.vue?vue&type=style&index=0&id=353fec18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353fec18",
  null
  
)

export default component.exports